import React from "react";
import styled from "styled-components";
import ngIcon from "../../assets/images/ico_ng.png";
import okIcon from "../../assets/images/ico_ok.png";
import naIcon from "../../assets/images/ico_na.png";
import ngIconB from "../../assets/images/ico_ng_b.png";
import okIconB from "../../assets/images/ico_ok_b.png";
import naIconB from "../../assets/images/ico_na_b.png";

const StyledButton = styled.button`
  display: inline-block;
  margin: 0 10px;
  border: none;
  cursor: pointer;

  img {
    vertical-align: middle;
  }
`;

const ActiveButton = ({ isActive, onClick, className, style }) => {
  const isBig = className === "big";

  const getButtonIcon = () => {
    switch (isActive) {
      case true:
        return isBig ? okIconB : okIcon;
      case false:
        return isBig ? ngIconB : ngIcon;
      default:
        return isBig ? naIconB : naIcon;
    }
  };

  const getAriaLabel = () => {
    switch (isActive) {
      case true:
        return "ok";
      case false:
        return "ng";
      default:
        return "na";
    }
  };

  const buttonIcon = getButtonIcon();
  const ariaLabel = getAriaLabel();

  return (
    <StyledButton onClick={onClick} aria-label={ariaLabel} style={style}>
      <img src={buttonIcon} alt={ariaLabel} />
    </StyledButton>
  );
};

export default ActiveButton;
